import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasEmpleadoprestamosLauncherComponent () {
}

module.component('finanzasEmpleadoprestamosLauncher', {
  controller: FinanzasEmpleadoprestamosLauncherComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/finanzas/_/empleadoprestamos/components/launcher/component.js